import { memo, ReactNode } from "react";
import { Flex } from "../flex";
import { Text } from "../text";
import { DisabledTooltip } from "../tooltip/disabled-tooltip";

export const DraggableFormElement = memo(function FormElement({
  name,
  Icon,
  description,
  disabled,
  disabledTooltip,
}: {
  name: string;
  Icon: ReactNode;
  description?: string;
  disabled?: boolean;
  disabledTooltip?: string;
}) {
  return (
    <DisabledTooltip
      disabledMessage={
        disabled && disabledTooltip ? disabledTooltip : undefined
      }
    >
      <Flex
        align="center"
        gap="md"
        id={`draggable-form-element-${name}`}
        py="sm"
        style={{
          opacity: disabled ? 0.5 : 1,
          cursor: disabled ? "not-allowed" : "move",
        }}
      >
        <Flex justify="center" textColor="tertiary">
          {Icon}
        </Flex>
        <Flex dir="column" gap="none">
          <Text fontSize="sm">{name}</Text>
          {description && <Text fontSize="xs">{description}</Text>}
        </Flex>
      </Flex>
    </DisabledTooltip>
  );
});
